import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import ChangePasswordForm from "../../Forms/ChangePasswordForm/ChangePasswordForm";
import { useTranslation } from "react-i18next";

const ChangeProfilePasswordModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:editProfile"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);

  const formName = "ChangePasswordForm";
  const { handleHide, show } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"500px"}
      height={"480px"}
      onClose={handleHide}
      header={t("global:changePassword")}
      buttons={buttons()}
      steps={steps}
    >
      <ChangePasswordForm
        isSubmit={isSubmit}
        steps={steps}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ChangeProfilePasswordModal" })(
  ChangeProfilePasswordModal
);
